<template>
  <VDivider
    v-if="slots['default']"
    :color="props.color"
    :thickness="props.thickness"
    :vertical="props.vertical"
  >
    <slot />
  </VDivider>
  <VDivider
    v-else
    :color="props.color"
    :thickness="props.thickness"
    :vertical="props.vertical"
  />
</template>
<script setup lang="ts">
import { useSlots } from "vue";
import { VueSlots } from "@/src/shared/types/slot";

interface Props {
  color?: string;
  thickness?: string | number;
  vertical?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  color: undefined,
  thickness: undefined,
  vertical: false,
});

const slots = useSlots() as VueSlots<["default"]>;
</script>
